import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetDepartment,
  UpdateDepartment,
} from "../../../store/department-store/department-actions";
import DepartmentForms from "../../../components/Forms/DepartmentForms";
import { getTokenInfo } from "../../../utils/Guard";

const DepartmentEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const department = useSelector((state) => state.department.department);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (department.id===undefined || department.id === 0) {
      dispatch(GetDepartment(param.departmentId, userInfo.Email));
    }
  }, [param.departmentId, userInfo.Email, dispatch, department]);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "118vh"}}>
      <DepartmentForms actionDepartment={UpdateDepartment} department={department} />
      </div>
    </>
  );
};
export default DepartmentEdit;
